import request from '../../request/request.js'

//delete服务器redis的token
export const DeleteTokenAPI = (token) => request.delete(`/token/delete?token=`+token)
 


